import type { MeProfile } from '@/api/services/me';

export function canViewWorkspaceActivity(me: MeProfile | null | undefined): boolean {
  return Boolean(
    me?.permissions.canViewWorkspaceActivity ?? me?.permissions.canViewCustomerActivity,
  );
}

export function canViewPlatformActivity(me: MeProfile | null | undefined): boolean {
  return Boolean(
    me?.permissions.canViewPlatformActivity ?? me?.permissions.canViewGlobalActivity,
  );
}

export function canBrowseTemplates(me: MeProfile | null | undefined): boolean {
  return me?.permissions.canBrowseTemplates === true;
}

export function canInstallTemplates(me: MeProfile | null | undefined): boolean {
  return me?.permissions.canInstallTemplate === true && !me?.permissions.readOnly;
}

export function canManageOrganizationTemplates(me: MeProfile | null | undefined): boolean {
  return Boolean(
    me?.permissions.canManageOrganizationTemplates ?? me?.permissions.canManageOrgTemplates,
  ) && !me?.permissions.readOnly;
}

export function canManagePersonalTemplates(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canManagePersonalTemplates) && !me?.permissions.readOnly;
}

export function canImportTemplates(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canImportTemplates) && !me?.permissions.readOnly;
}

export function canExportTemplates(me: MeProfile | null | undefined): boolean {
  return me?.permissions.canExportTemplates === true && !me?.permissions.readOnly;
}

export function canExportSearches(me: MeProfile | null | undefined): boolean {
  return me?.permissions.canExportSearches === true && !me?.permissions.readOnly;
}

export function canFavoriteTemplates(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canFavoriteTemplates) && !me?.permissions.readOnly;
}

export function canManageRecipients(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canManageRecipients) && !me?.permissions.readOnly;
}

export function canCreateRecipient(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canCreateRecipient) && !me?.permissions.readOnly;
}

export function canEditRecipient(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canEditRecipient) && !me?.permissions.readOnly;
}

export function canDeleteRecipient(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canDeleteRecipient) && !me?.permissions.readOnly;
}

export function canTestRecipient(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canTestRecipient) && !me?.permissions.readOnly;
}

export function canViewWorkspaceUsers(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canViewWorkspaceUsers);
}

/** @deprecated Use canViewWorkspaceUsers */
export function canViewWorkspaceUsersNav(me: MeProfile | null | undefined): boolean {
  return canViewWorkspaceUsers(me);
}

export function canViewCustomerBillingNav(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canViewCustomerBilling);
}

export function canViewQuickSetup(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canCreateSearch) && !me?.permissions.readOnly;
}

export function canViewWorkspaceUsage(me: MeProfile | null | undefined): boolean {
  return Boolean(
    me?.permissions.canViewCustomerActivity
      ?? me?.permissions.canViewWorkspaceActivity
      ?? me?.permissions.canViewRecipients
      ?? me?.permissions.canCreateSearch,
  );
}

export function canViewRecipientsNav(me: MeProfile | null | undefined): boolean {
  return Boolean(me?.permissions.canViewRecipients);
}

export function canViewSubscriptions(me: MeProfile | null | undefined): boolean {
  return me?.permissions.canViewSubscriptions === true;
}

export function canManageSubscriptions(me: MeProfile | null | undefined): boolean {
  return Boolean(
    me?.permissions.canManageSubscriptions ?? me?.permissions.canCreateSubscription,
  ) && !me?.permissions.readOnly;
}

export function canCreateSubscription(me: MeProfile | null | undefined): boolean {
  return me?.permissions.canCreateSubscription === true && !me?.permissions.readOnly;
}

export function canEditSubscription(me: MeProfile | null | undefined): boolean {
  return Boolean(
    me?.permissions.canEditSubscription ?? me?.permissions.canCreateSubscription,
  ) && !me?.permissions.readOnly;
}

export function canDeleteSubscription(me: MeProfile | null | undefined): boolean {
  return Boolean(
    me?.permissions.canDeleteSubscription ?? me?.permissions.canCreateSubscription,
  ) && !me?.permissions.readOnly;
}
